<template>
  <div class="container">
    <div class="title">{{ $t('doc.gen_token_title') }}</div>
    <div class="content main" v-for="(item,index) in info" :key="item.title">
      <template v-if="!item.tableData">
        <div class="listTitle">{{ item.title }}</div>
        <div :style="{color: index == 1 ? '#0077FF' : ''}">{{ item.content }}</div>
      </template>
      <template v-else>
        <div class="listTitle">
          {{ item.title }}
        </div>
        <div class="table">
          <el-table
            :data="item.tableData"
            :header-cell-style="{
              backgroundColor: '#0077FF',
              color: '#FFF',
              fontWeight: '500',
            }"
          >
            <el-table-column
              v-for="(column, index) in item.tableKey"
              :key="column"
              :prop="column"
              :label="item.tableName[index]"
            >
            </el-table-column>
            <!-- <el-table-column prop="tips" label="提示"> </el-table-column> -->
          </el-table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenWebToken",

  data() {
    return {};
  },
  computed: {
    // info 转 computed：文档文案随语言热切换
    info() {
      const key = ["name", "type", "require", "example", "describe"];
      const col = [this.$t("doc.col_name"), this.$t("doc.col_type"), this.$t("doc.col_require"), this.$t("doc.col_example"), this.$t("doc.col_describe")];
      return [
        { title: this.$t("doc.s_desc"), content: this.$t("doc.token_desc") },
        { title: this.$t("doc.s_addr"), content: this.$t("doc.addr_token") },
        { title: this.$t("doc.s_req_type2"), content: "post" },
        {
          title: this.$t("doc.s_req_param"), content: "",
          tableData: [
            { name: "appkey", type: "string", require: "Y", example: "", describe: this.$t("doc.d_appkey") },
            { name: "appSecret", type: "string", require: "Y", example: "", describe: this.$t("doc.d_appsecret") },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_resp_param"), content: "",
          tableData: [
            { name: "code", type: "string", require: "Y", example: "", describe: this.$t("doc.d_code") },
            { name: "msg", type: "string", require: "Y", example: this.$t("doc.e_success"), describe: this.$t("doc.d_msg") },
            { name: "data", type: "object", require: "", example: "", describe: "" },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_data"), content: "",
          tableData: [
            { name: "token", type: "string", require: "Y", example: "", describe: this.$t("doc.d_token") },
          ],
          tableKey: key, tableName: col,
        },
      ];
    },
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
.title {
  padding: 10px 0;
  font-size: 24px;
  font-weight: 500;
}
.listTitle{
  font-weight: 500;
}
.main > div {
  margin: 20px 0;
  // background-color: red;
}
.table {
  width: 75%;
}
.main:last-child{
  padding-bottom: 100px;
}
</style>